import { Component, computed, inject, input, output, viewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubmittableForm, TransitionFormData, TransitionFormValue } from '@module-definition/document/common';
import { TransitionFormComponent } from '@module-definition/document/transition-form/transition-form.component';
import { DocumentDetailsStore } from '../common';

@Component({
  selector: 'cipo-details-transition',
  imports: [TransitionFormComponent],
  //   templateUrl: './details-transition.component.html',
  template: `
    @if (transitionData()) {
      <cipo-transition-form
        #transitionFormComponent
        [form]="form()"
        [data]="transitionData()"
        [compactMode]="compactMode()"
        (transitionFormPrepared)="transitionFormPrepared.emit($event)" />
    }
  `,
})
export class DetailsTransitionComponent implements SubmittableForm {
  private dmStore = inject(DocumentDetailsStore);
  transitionFormRef = viewChild<SubmittableForm>('transitionFormComponent');
  form = input.required<FormGroup>();
  entityInstanceId = input.required<number>();
  compactMode = input(false);
  transitionFormPrepared = output<TransitionFormValue>();

  transitionData = computed<TransitionFormData>(() => {
    const document = this.dmStore.documents()[this.entityInstanceId()];
    if (!document?.transitionData) {
      return null;
    }
    const {
      transitionData: { gridFields, notificationData },
      params: { contractId, moduleId },
    } = document;
    return {
      contractId,
      moduleId,
      fields: gridFields?.fields,
      notificationData,
      signatureIsRequired: gridFields?.requiresNonBindingSignature,
    };
  });

  submit() {
    this.transitionFormRef().submit();
  }
}
